import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import FGVLogo from "assets/img/fgv-logo.png";
import { Button, Typography } from "@material-ui/core";
import DefaultLayout from "layouts/DefaultLayout";
import { getRedirectUrl } from "utils";
import { useHistory, Redirect } from "react-router-dom";
import { useAuth } from "views/Authentication/AuthContext";
import LoadingIcon from "../../components/LoadingIcon/LoadingIcon";
import { useTranslation } from "react-i18next";

const LOGOUT_KEY = "LOGOUT";

const Error = ({ code, message, fullScreen, redirect, ...rest }) => {
  const { t } = useTranslation();
  const { logout, loggedIn } = useAuth();
  const history = useHistory();
  const [url, setUrl] = useState(null);

  const handleRedirect = (event) => {
    event.preventDefault();
    if (redirect) {
      let redUrl = getRedirectUrl();
      if (redUrl) {
        setUrl(redUrl);
      } else {
        setUrl(LOGOUT_KEY);
      }
    }
  };

  useEffect(() => {
    if (url === LOGOUT_KEY) {
      logout(true);
    } else if (url !== null) {
      return history.push(url);
    }
  }, [url]);

  let loggingIn = <LoadingIcon text={"Logging in"} image />;

  let error = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <img src={FGVLogo} alt="FGV" width={200} />
      <Typography color="textPrimary" variant="h1">
        {code}
      </Typography>
      <Typography color="textPrimary" variant="h4">
        {t(message)}
      </Typography>
      {redirect ? (
        <Button
          onClick={handleRedirect}
          style={{ margin: "20px" }}
          variant="contained"
          color="primary"
        >
          Back to Home
        </Button>
      ) : null}
    </div>
  );
  if (!loggedIn) {
    return <Redirect to="/" />;
  }
  if (fullScreen) {
    return (
      <DefaultLayout>
        {rest.location && rest.location.state && rest.location.state.login
          ? loggingIn
          : error}
      </DefaultLayout>
    );
  }
  if (rest.location && rest.location.state && rest.location.state.login) {
    return loggingIn;
  }
  return error;
};

Error.propTypes = {
  code: PropTypes.number,
  message: PropTypes.string,
  fullScreen: PropTypes.bool,
  redirect: PropTypes.bool,
};

Error.defaultProps = {
  code: 404,
  message: "Page Not Found",
  fullScreen: false,
  redirect: false,
};

export default Error;
